import React, { forwardRef } from 'react';
import { Bar } from 'react-chartjs-2';

const SectorExposureChart = forwardRef(({ data, colours = {} }, ref) => {
  if (!data || data.length === 0) return <div className="chart-placeholder">No allocation data available</div>;

  const labels = data.map(d => d.asset_class);
  const actualWeights = data.map(d => d.actual_weight ?? d.weight ?? 0);
  const saaWeights = data.map(d => d.saa_weight ?? 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Actual',
        data: actualWeights,
        backgroundColor: colours.sector_actual || '#072040',
        barPercentage: 0.8,
        categoryPercentage: 0.7,
      },
      {
        label: 'SAA',
        data: saaWeights,
        backgroundColor: colours.sector_saa || '#599BE3',
        barPercentage: 0.8,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: { font: { size: 10 }, boxWidth: 20, boxHeight: 2, padding: 5 },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        border: { display: false },
        grid: { display: false },
        ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
      },
      y: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: {
          font: { size: 10 },
          callback: (val) => `${val}%`,
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
      <Bar ref={ref} data={chartData} options={options} />
    </div>
  );
});

SectorExposureChart.displayName = 'SectorExposureChart';
export default SectorExposureChart;
